import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Target, Calendar } from "lucide-react";
import api from "@/lib/api";
import { GUIDE_IMG, MEDIA } from "@/lib/media";

export default function Challenges() {
  const [challenges, setChallenges] = useState([]);
  useEffect(() => { api.get("/challenges").then((r) => setChallenges(r.data)).catch(() => {}); }, []);

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 py-12">
      <div className="max-w-2xl">
        <span className="inline-flex items-center gap-2 rounded-full bg-rose/40 px-4 py-1.5 text-sm font-semibold text-plum">
          <Target className="h-4 w-4 text-teal" /> Challenges
        </span>
        <h1 className="mt-4 font-display text-4xl sm:text-5xl text-plum">Start any day, at your pace</h1>
        <p className="mt-3 text-mutedplum text-lg">Short, doable challenges to build momentum. No leaderboards, no pressure—just you, getting a little stronger.</p>
      </div>

      <h2 className="mt-12 font-display text-2xl text-plum">Browse all challenges</h2>
      <div className="mt-6 grid md:grid-cols-3 gap-6">
        {challenges.map((c, i) => (
          <motion.div key={c.slug} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: i * 0.08 }}>
            <Link to={`/challenges/${c.slug}`} data-testid={`challenge-card-${c.slug}`}
              className="group block bg-white rounded-3xl border border-rose/30 shadow-card overflow-hidden hover:-translate-y-1 hover:shadow-soft transition-[transform,box-shadow] duration-300 h-full">
              <div className="h-44 overflow-hidden relative">
                <img src={GUIDE_IMG[c.image_key] || MEDIA.hero} alt={c.title} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
                {c.featured && <span className="absolute top-3 left-3 rounded-full bg-teal px-3 py-1 text-xs font-semibold text-white">Featured</span>}
              </div>
              <div className="p-6">
                <span className="inline-flex items-center gap-1.5 text-sm text-mutedplum"><Calendar className="h-4 w-4" /> {c.duration_days} days</span>
                <h3 className="mt-2 font-display text-xl text-plum leading-snug group-hover:text-teal transition-colors">{c.title}</h3>
                <p className="mt-2 text-[15px] text-mutedplum line-clamp-2">{c.subtitle}</p>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
